export default {
  metadata: {
    version: '1.0.0',
    id: 'promo-card-1.0.0',
    name: 'JDSPromoCard',
    description:
      'Promotional cards are compositions of text and images intended to promote a specific service or feature.',
    usage:
      'Promotional cards are used to announce a new feature or motivate users to take an action.'
  },
  hierarchy: {
    'root-container': [
      {
        'vertical-container': [
          {
            'vertical-image-container': [
              'vertical-jds_image',
              'vertical-promoCardArc'
            ]
          },
          {
            'vertical-content-container': ['vertical-jds_content_block']
          }
        ]
      },
      {
        'horizontal-container': [
          {
            'horizontal-content-container': ['horizontal-jds_content_block']
          },
          {
            'horizontal-image-container': [
              'horizontal-image',
              'horizontal-promoCardArc'
            ]
          }
        ]
      },
      {
        'footer-container': ['prefix-slot', 'suffix-slot']
      }
    ]
  },
  base: {
    'root-container': {
      'background-color': '{p_0}',
      'flex-direction': '{p_1}',
      width: '{p_2}',
      'justify-content': '{p_3}',
      'align-items': '{p_4}',
      'border-radius': '{p_5}',
      'box-shadow': {
        x: 0,
        y: 4,
        blur: 16,
        spread: 0,
        color: '#00000014'
      }
    },
    'vertical-container': {
      mode: 'bold',
      'flex-direction': '{p_6}',
      'align-items': '{p_7}',
      'justify-content': '{p_8}',
      width: '{p_9}',
      'border-radius': '{p_10}',
      'background-color': '{p_11}',
      overflow: 'hidden'
    },
    'horizontal-container': {
      hidden: true,
      mode: 'bold',
      'flex-direction': '{p_12}',
      'align-items': '{p_13}',
      'justify-content': '{p_14}',
      width: '{p_15}',
      'border-radius': '{p_16}',
      height: '{p_17}',
      'background-color': '{p_18}',
      overflow: 'hidden'
    },
    'vertical-content-container': {
      'flex-direction': '{p_19}',
      'align-items': '{p_20}',
      'justify-content': '{p_21}',
      width: '{p_22}',
      mode: 'bold',
      'background-color': '{p_23}',
      'border-bottom-left-radius': '{p_24}',
      'border-bottom-right-radius': '{p_25}',
      'padding-right': '{p_26}',
      'padding-bottom': '{p_27}',
      'padding-left': '{p_28}'
    },
    'horizontal-content-container': {
      'flex-direction': '{p_29}',
      'align-items': '{p_30}',
      'justify-content': '{p_31}',
      height: '{p_32}',
      mode: 'bold',
      'background-color': '{p_33}',
      flex: 1,
      'padding-top': '{p_34}',
      'padding-right': '{p_35}',
      'padding-bottom': '{p_36}',
      'padding-left': '{p_37}'
    },
    'vertical-jds_content_block': {
      mode: 'bold',
      size: 'small'
    },
    'horizontal-jds_content_block': {
      mode: 'bold',
      size: 'small'
    },
    'vertical-image-container': {
      width: '{p_38}',
      'flex-direction': '{p_39}',
      'align-items': '{p_40}'
    },
    'horizontal-image-container': {
      flex: 1,
      height: '{p_41}',
      'flex-direction': '{p_42}',
      'align-items': '{p_43}',
      'justify-content': '{p_44}'
    },
    'vertical-jds_image': {
      aspectRatio: 'horizontal_16_9',
      roundedCorner: false
    },
    'horizontal-image': {
      overflow: 'hidden',
      height: '{p_45}',
      'object-position': 'center',
      'object-fit': 'cover',
      'aspect-ratio': '{aspect_ratio.16.9}'
    },
    'vertical-promoCardArc': {
      mode: 'bold',
      color: '{p_46}',
      orientation: 'vertical',
      width: '{p_47}',
      height: '{p_48}',
      'z-index': 1
    },
    'horizontal-promoCardArc': {
      mode: 'bold',
      color: '{p_49}',
      orientation: 'horizontal',
      height: '{p_50}',
      width: '{p_51}',
      'z-index': 1
    },
    'footer-container': {
      color: '{p_52}',
      width: '{p_53}',
      'justify-content': '{p_54}',
      'align-items': '{p_55}',
      'flex-direction': '{p_56}',
      gap: '{p_57}',
      'padding-left': '{p_58}',
      'padding-right': '{p_59}',
      'padding-top': '{p_60}',
      'padding-bottom': '{p_61}',
      mode: 'light',
      show: false
    }
  },
  variant: {
    imageRatio: {
      square: {
        'vertical-jds_image': {
          aspectRatio: 'square'
        },
        'horizontal-image': {
          'aspect-ratio': '{aspect_ratio.1.1}'
        }
      },
      landscape: {
        'vertical-jds_image': {
          aspectRatio: 'horizontal_4_3'
        },
        'horizontal-image': {
          'aspect-ratio': '{aspect_ratio.4.3}'
        }
      },
      portrait: {
        'vertical-jds_image': {
          aspectRatio: 'vertical_4_5'
        },
        'horizontal-image': {
          'aspect-ratio': '{aspect_ratio.4.5}'
        }
      }
    },
    imageFocus: {
      left: {
        'vertical-jds_image': {
          imageFocus: 'left'
        },
        'horizontal-image': {
          'object-position': 'left'
        }
      },
      right: {
        'vertical-jds_image': {
          imageFocus: 'right'
        },
        'horizontal-image': {
          'object-position': 'right'
        }
      },
      top: {
        'vertical-jds_image': {
          imageFocus: 'top'
        },
        'horizontal-image': {
          'object-position': 'top'
        }
      },
      bottom: {
        'vertical-jds_image': {
          imageFocus: 'bottom'
        },
        'horizontal-image': {
          'object-position': 'bottom'
        }
      }
    },
    shadow: {
      false: {
        'root-container': {
          'box-shadow': {
            x: 0,
            y: 0,
            blur: 0,
            spread: 0,
            color: '#00000000'
          }
        }
      }
    },
    size: {
      'xtra-small': {
        'vertical-jds_content_block': {
          size: 'xtra-small'
        },
        'horizontal-jds_content_block': {
          size: 'xtra-small'
        }
      },
      medium: {
        'vertical-jds_content_block': {
          size: 'medium'
        },
        'horizontal-jds_content_block': {
          size: 'medium'
        },
        'horizontal-content-container': {
          'padding-top': '{p_62}',
          'padding-right': '{p_63}',
          'padding-bottom': '{p_64}',
          'padding-left': '{p_65}'
        }
      },
      large: {
        'vertical-jds_content_block': {
          size: 'large'
        },
        'horizontal-jds_content_block': {
          size: 'large'
        },
        'horizontal-content-container': {
          'padding-top': '{p_66}',
          'padding-right': '{p_67}',
          'padding-bottom': '{p_68}',
          'padding-left': '{p_69}'
        }
      }
    },
    orientation: {
      horizontal: {
        'vertical-container': {
          hidden: true
        },
        'horizontal-container': {
          hidden: false
        }
      }
    },
    _hasFooter: {
      false: {
        'footer-container': {
          hidden: true
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    children: {
      'prefix-slot': {
        name: 'footerPrefix',
        accepts: ['jds_text'],
        max: 1,
        doc_description:
          'footerPrefix corresponds to the left part of the footer. Incase of a String, a text with style body-xxs with grey-100 color is shown'
      },
      'suffix-slot': {
        name: 'footerSuffix',
        accepts: ['jds_text'],
        max: 1,
        doc_description:
          'footerSuffix corresponds to the right part of the footer. Incase of a String, a text with style body-xxs with grey-100 color is shown'
      }
    },
    config: {
      size: {
        values: ['small', 'xtra-small', 'medium', 'large'],
        doc_description:
          'Determines the size of the PromoCard. Size dictates the text and spacing.'
      },
      orientation: {
        values: ['vertical', 'horizontal'],
        doc_description:
          'Horizontal orientation puts image and content side by side.'
      },
      imageRatio: {
        values: ['wide', 'square', 'landscape', 'portrait']
      },
      imageFocus: {
        type: 'JDSImage.imageFocus',
        values: ['center', 'left', 'right', 'top', 'bottom']
      },
      shadow: {
        values: [true, false],
        doc_description: 'Toggle drop shadow'
      },
      _hasFooter: {
        values: [true, false]
      }
    },
    data: {
      'horizontal-jds_content_block': {
        title: {
          type: 'string',
          name: 'title',
          doc_description: 'The main title copy.'
        },
        description: {
          type: 'string',
          name: 'description',
          doc_description:
            'Accepts description as string. JSX.Element is also allowed in case you have anchor tags inside your richtext.'
        },
        primaryCTA: {
          type: 'string',
          name: 'primaryCTA'
        },
        children: {
          type: 'slot',
          name: 'children'
        }
      },
      'vertical-jds_content_block': {
        title: {
          type: 'string',
          name: 'title',
          doc_description: 'The main title copy.'
        },
        description: {
          type: 'string',
          name: 'description',
          doc_description:
            'Accepts description as string. JSX.Element is also allowed in case you have anchor tags inside your richtext.'
        },
        primaryCTA: {
          type: 'string',
          name: 'primaryCTA'
        },
        children: {
          type: 'slot',
          name: 'children'
        }
      },
      'horizontal-image': {
        value: {
          type: 'image',
          name: 'image'
        }
      },
      'vertical-jds_image': {
        src: {
          type: 'image',
          name: 'image'
        }
      }
    },
    events: {
      'root-container': {
        onClick: 'onClick'
      },
      'horizontal-jds_content_block': {
        onPrimaryClick: 'onPrimaryClick'
      },
      'vertical-jds_content_block': {
        onPrimaryClick: 'onPrimaryClick'
      }
    },
    a11y: {
      'horizontal-jds_content_block': {
        properties: {
          primaryCtaAriaLabel: 'primaryCtaAriaLabel',
          primaryCtaAriaDescribedby: {
            name: 'primaryCtaAriaDescribedby',
            platform: 'web,ios'
          },
          secondaryCtaAriaLabel: 'secondaryCtaAriaLabel',
          secondaryCtaAriaDescribedby: {
            name: 'secondaryCtaAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'vertical-jds_content_block': {
        properties: {
          primaryCtaAriaLabel: 'primaryCtaAriaLabel',
          primaryCtaAriaDescribedby: {
            name: 'primaryCtaAriaDescribedby',
            platform: 'web,ios'
          },
          secondaryCtaAriaLabel: 'secondaryCtaAriaLabel',
          secondaryCtaAriaDescribedby: {
            name: 'secondaryCtaAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'vertical-jds_image': {
        properties: {
          ariaLabel: 'imageAriaLabel',
          ariaDescribedby: {
            name: 'imageAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'horizontal-image': {
        properties: {
          ariaLabel: 'imageAriaLabel',
          ariaDescribedby: {
            name: 'imageAriaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
